import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser } from "./api/auth";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyUser = async () => {
      try {
        await getUser();
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
        navigate("/login");
      }
    };

    verifyUser();
  }, [navigate]);

  // While checking, you can show a loading spinner or null
  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // Render the protected content if authenticated, otherwise redirect will occur
  return <>{children}</>;
};

export default ProtectedRoute;
